import { WorkshopApi } from './workshopDetailsApi';

function formatClientData(client) {
  return {
    empresa: client.empresa || client.company,
    nome: client.nome || client.name,
    telefone: client.telefone || client.phone,
    cnpj: client.cnpj || client.cnpj,
    dt_criacao: client.dt_criacao || client.created_at,
    email: client.email || client.email
  };
}

function formatEstimateData(estimate) {
  return {
    id: estimate.id,
    status: estimate.status,
    endereco: estimate.endereco || estimate.address,
    itens: Array.isArray(estimate.itens) ? estimate.itens :
      typeof estimate.itens === 'string' ? JSON.parse(estimate.itens || '[]') : [],
    texto_resposta: estimate.texto_resposta || estimate.response_text,
    valor_resposta: estimate.valor_resposta || estimate.response_value,
    motivo_recusa: estimate.motivo_recusa || estimate.refusal_reason,
    user_id: estimate.user_id || estimate.user_id,
    orcamento_id: estimate.orcamento_id || estimate.budget_id,
    created_at: estimate.created_at || estimate.created_at,
    updated_at: estimate.updated_at || estimate.updated_at
  };
}

function formatBudgetData(budget) {
  return {
    id: budget.id,
    status: budget.status,
    valor: budget.valor || budget.value,
    observacoes: budget.observacoes || budget.observations,
    itens: Array.isArray(budget.itens) ? budget.itens.map(item => ({
      equip_id: item.equip_id || item.equipment_id,
      equipamento_nome: item.equipamento_nome || item.equipment_name,
      equipamento_marca: item.equipamento_marca || item.equipment_brand,
      equipamento_modelo: item.equipamento_modelo || item.equipment_model,
      equipamento_serie: item.equipamento_serie || item.equipment_serial,
      tipo_item: item.tipo_item || item.item_type,
      codigo_interno: item.codigo_interno || item.internal_code,
      nome: item.nome || item.name,
      qtd: item.qtd || item.quantity,
      valor: item.valor || item.value
    })) : [],
    created_at: budget.created_at || budget.created_at,
    updated_at: budget.updated_at || budget.updated_at
  };
}

function formatWorkshopDetailsData(data) {
  return {
    cliente: data.cliente ? formatClientData(data.cliente) : null,
    estimativa: data.estimativa ? formatEstimateData(data.estimativa) : null,
    orcamento: data.orcamento ? formatBudgetData(data.orcamento) : null,
    rotasimplesempresa: data.rotasimplesempresa || data.company_slug
  };
}

function formatarData(dataString) {
  if (!dataString) return '--';
  const data = new Date(dataString);
  return data.toLocaleDateString('pt-BR');
}

function formatarMoeda(valor) {
  if (valor == null || valor === "") return "-";
  return Number(valor).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL"
  });
}

function groupBudgetItemsByEquipment(itens) {
  const agrupados = {};

  itens.forEach(item => {
    if (!agrupados[item.equip_id]) {
      agrupados[item.equip_id] = [];
    }
    agrupados[item.equip_id].push(item);
  });

  return agrupados;
}

function calculateBudgetTotals(itens) {
  let totalPecas = 0;
  let totalProcedimentos = 0;

  itens.forEach(item => {
    const qtd = Number(item.qtd) || 1;
    const valor = Number(item.valor) || 0;
    const total = qtd * valor;

    if (item.tipo_item === "peca") {
      totalPecas += total;
    } else if (item.tipo_item === "procedimento") {
      totalProcedimentos += total;
    }
  });

  return {
    totalPecas,
    totalProcedimentos,
    totalGeral: totalPecas + totalProcedimentos
  };
}

// Funções principais do serviço
function getWorkshopDetails(id) {
  return WorkshopApi.getWorkshopDetails(id)
    .then(response => formatWorkshopDetailsData(response.data));
}

async function receiveEquipment(quotationId) {
  try {
    const response = await WorkshopApi.receiveEquipment(quotationId);
    return response.data;
  } catch (error) {
    console.error('Erro no serviço receiveEquipment:', error);
    throw error;
  }
}

async function submitApontamentos(quotationId, apontamentos) {
  try {
    const payload = { apontamentos };
    const response = await WorkshopApi.submitApontamentos(quotationId, payload);
    return response.data;
  } catch (error) {
    console.error('Erro no serviço submitApontamentos:', error);
    throw error;
  }
}

function loadBudget(userId, empresa, orcamentoId, estimativaId) {
  const data = {
    user_id: userId,
    empresa: empresa,
    orcamento_id: orcamentoId,
    estimativa_id: estimativaId
  };

  return WorkshopApi.loadBudget(data)
    .then(response => ({
      success: true,
      data: response.data,
      redirect_url: `#orcamento?user_id=${userId}&empresa=${empresa}&orcamento_id=${orcamentoId}&estimativa_id=${estimativaId}`
    }));
}

function registerEquipment(equipmentData) {
  return WorkshopApi.registerEquipment(equipmentData)
    .then(response => ({
      success: true,
      data: response.data,
      message: "Equipamento cadastrado com sucesso"
    }));
}

export const WorkshopService = {
  getWorkshopDetails,
  receiveEquipment,
  submitApontamentos,
  loadBudget,
  registerEquipment,
  formatClientData,
  formatEstimateData,
  formatBudgetData,
  formatWorkshopDetailsData,
  formatarData,
  formatarMoeda,
  groupBudgetItemsByEquipment,
  calculateBudgetTotals
};